import "@ingka/focus/dist/style.css"
import Hyperlink from "@ingka/hyperlink"
import "@ingka/hyperlink/dist/style.css"
import Image from "@ingka/image"
import "@ingka/image/dist/style.css"
import "@ingka/svg-icon/dist/style.css"
import {IDexfSettings, ITranslations} from "@inter-ikea-kompis/types"
import {FC, useEffect, useState} from "react"
import DexfSettings from "../Utils/DexfSettings"
import Localization from "./../Utils/TranslationHelper"

const Header: FC = () => {
  const [localization, setLocalization] = useState<ITranslations>()

  const [settings, setSettings] = useState<IDexfSettings>()

  useEffect(() => {
    const localization = new Localization()
    const dexfSettings = new DexfSettings()

    dexfSettings.getSettings().then((data) => {
      if (data) {
        setSettings(data)
      }
    })

    localization.getLocalization().then((data) => {
      if (data) {
        setLocalization(data)
      }
    })
  }, [])
  if (!settings || !localization) {
    return <></>
  }
  return (
    <div className="container">
      <div dir={settings.localisation.writeDirection} className="Header">
        <Hyperlink url={settings.kompis.urls.homePageLink}>
          <Image
            src={"https://www.ikea.com/global/assets/logos/brand/ikea.svg"}
            alt={
              !localization ? undefined : localization.kompis.ikeaLogoAriaLabel
            }
            className="Logo-main"
          />
        </Hyperlink>
      </div>
    </div>
  )
}

export default Header
